export const loadTransactionSignature = (
  registerId: string,
  registerSalePaymentId: string
) => {
  return new Promise<string>((resolve, reject) => {
    const signature = new Image()
    const imageSrc = `/api/2.0/registers/${registerId}/transactions/${registerSalePaymentId}/signature.png`

    signature.addEventListener('load', () => resolve(imageSrc))
    signature.addEventListener('error', () =>
      reject(new Error('Failed to load signature image'))
    )

    signature.src = imageSrc
  })
}
